export const isOpen = state => state.profileSelectorReducer.open
export const getUserId = state => state.profileSelectorReducer.userId
export const getTitle = state => state.profileSelectorReducer.title
export const getBoundingRectangle = state => state.profileSelectorReducer.boundingRectangle
export const getManageProfilesText = state => state.profileSelectorReducer.manageProfiles



// WEBPACK FOOTER //
// ./src/features/ProfileSelector/data/selectors.js